import {login, logout, getInfo, getBranchInfo} from '@/api/login'
import {getToken, setToken, removeToken} from '@/utils/auth'
import {Priv} from '@/utils/Priv'

const user = {
  state: {
    token: getToken(),
    name: '',
    userId:'',
    userName: '',
    avatar: '',
    roles: [],
    branchInnerCode: '',
    branchName: '',
    branchType: '',
    branchParentInnerCode: '',
    branchParentName: '',
    priv: {},
    menus: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERID: (state, id) => {
      state.userId = id
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_BRANCH_NAME: (state, branchName) => {
      state.branchName = branchName
    },
    setBranchType: (state, branchType) => {
      state.branchType = branchType
    },
    SET_BRANCH_INNER_CODE: (state, branchInnerCode) => {
      state.branchInnerCode = branchInnerCode
    },
    SET_BRANCH_PARENT_NAME: (state, branchParentName) => {
      state.branchParentName = branchParentName
    },
    SET_BRANCH_PARENT_INNER_CODE: (state, branchParentInnerCode) => {
      state.branchParentInnerCode = branchParentInnerCode
    },
    SET_PRIV: (state, priv) => {
      state.priv = priv
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    }
  },

  actions: {
    // 登录
    Login({commit}, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          // console.log('login success');
          // console.log(response);
          const data = response.data;
          setToken(data.token);
          commit('SET_TOKEN', data.token);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 单点登录
    // IntegrationLogin({commit}, xtoken) {
    //   return new Promise((resolve, reject) => {
    //     setToken(xtoken);
    //     commit('SET_TOKEN', xtoken);
    //     resolve()
    //   })
    // },
    IntegrationLogin({ commit }) {
      return new Promise((resolve, reject) => {
        // setToken(xtoken);
        // commit('SET_TOKEN', xtoken);
        resolve()
      })
    },

    // 获取用户信息
    GetInfo({commit, state}) {
      function buildRoute(menu, isTop) {
        return {
          path: '/' + menu.url,
          component: isTop ? 'Layout' : menu.url,
          // redirect: '',
          name: menu.code,
          // hidden: true,
          // 需要登录才能进入的页面可以增加一个meta属性
          meta: {
            requireAuth: true,
            menuDisplay: 'second',
            'title': menu.name,
            'icon': menu.iconClass
          },
          children: []
        }
      }

      function buildRoutesFromMenus(flatMenus) {
        console.log(flatMenus)
        let routes = [];
        let routerMap = {};
        for (let i = 0; i < flatMenus.length; i++) {
          let flatMenu = flatMenus[i];
          let flatMenuParentInnerCode = flatMenu.parentInnerCode;
          let parentRoute = routerMap[flatMenuParentInnerCode];
          console.log(parentRoute)
          let route = buildRoute(flatMenu, !parentRoute);
          if (parentRoute) {
            if (parentRoute.children.length === 0) {
              parentRoute.redirect = route.path;
            }
            parentRoute.children.push(route);
          } else {
            routes.push(route);
          }
          console.log(route)
          routerMap[flatMenu.innerCode] = route;
        }
        routes[0].path = '/';
        return routes;
      }

      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          // console.log('GetInfo success');
          console.log("user:",response);
          const data = response.data;
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject(new Error('该用户没有设置任何角色，请联系管理员!'))
          }
          // const info = {
          //   IS_OPEN_WEBSITE: DisciplineConfig.IS_OPEN_WEBSITE
          // };
          // getBranchInfo(info).then(response1 => {
            commit('SET_NAME', data.name);
            commit('SET_USERNAME', data.userName);
            commit('SET_AVATAR', data.avatar);
            commit('SET_BRANCH_INNER_CODE', data.branchInnerCode);
            commit('SET_BRANCH_NAME', data.branchName);
            commit('setBranchType', data.branchType);
            commit('SET_BRANCH_PARENT_INNER_CODE', data.branchParentInnerCode);
            commit('SET_BRANCH_PARENT_NAME', data.branchParentName);
            commit('SET_PRIV', JSON.parse(data.priv || '{}'));
            // console.log(data.menus);
            let menus = JSON.parse(data.menus);
            let testMenus = [
              {
                path: '/',
                innerCode: '001',
                component: 'Layout'
              },
              // {
              //   name: '系统资料',
              //   code: 'leadershipinterface',
              //   innerCode: '001002',
              //   parentInnerCode: '001',
              //   url: 'Help',
              //   iconClass: 'el-icon-jw-yunzhuomian'
              // }
            ];
            testMenus.forEach((menu) => {
              menus.push(menu);
            });
            let router = buildRoutesFromMenus(menus);
            data.menus = router;
            commit('SET_MENUS', router);
            Priv.init(data.priv);
            resolve(response)
          // }).catch(error => {
          //   reject(error)
          // })
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({commit, state}) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          localStorage.clear();
          removeToken();
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        resolve()
      })
    }
  }
};

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js